import { fillActivateStudents } from "../../Pages/AdminCourseManagement/Fills";
import { changeCourseListUserCounter } from "../../Pages/AdminCourseManagement/UserCounters";
import { ajaxRequest } from "../../Utils/Ajax/ajax";
import { loadTooltips } from "../../Utils/Ajax/loadTooltips";
import { parseExcel } from "../../Utils/Excel/ExcelToJson";
import { checkEmail, errorToast, hideModal, infoToast, successToast } from "../../Utils/utils";
import { addEmailField, refreshEmailFields } from "./ActivationModal";


export class ActivateStudents {
    holder:JQuery;
    activationType: null | string;
    submitBtn:JQuery;
    courseId: number;
    room: number;
    inited:boolean;
    role:string;

    constructor(courseId:number, role:string){
        this.courseId = courseId
        this.inited = false;
        this.activationType = 'email'
        this.role = role
    }

    init(){
        this.holder = $("#students-activation");
        this.submitBtn = $(".activate-students");
        // build();        
        // actual courseId
        //
        if (!this.inited){
            this.addListeners();
            this.initDropzone();
            this.inited = true
        }
    }

    initDropzone(){
        const handler = this;
        const dropzone = new Dropzone('form#excel', {
            autoQueue: false,
            acceptedFiles: ".xls,.xlsx,.csv",
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            addedfile: function(file){
                
                parseExcel(file, function(json_object){
                    window.students = JSON.parse(json_object);
                    successToast("Es wurden " + JSON.parse(json_object).length + " Schüler erkannt", "Erfolg", 8500, true);
                    

                    handler.addExcelStudents(window.students);
                });
                
            }
        });
    }

    addListeners(){
        
        const handler = this;
        $(document).on("click", ".btn-students-activate", function(){
             if (handler.activationType == null){
                 $(".a-s-t").removeClass("h4").addClass("h6");
                 $(".activate-students").show();
                 $(".btn-students-activate").removeClass("btn-xl").addClass("btn-lg");
                 $(".dropdown-students-activate").show();
             }
             handler.activationType = $(this).attr("data-type");
             handler.showOption();
        });

        $(document).on("click", ".activate-students", function(){
            if (!$(this).prop("disabled")){
                
                handler.submit($(this));
            }
        });

        this.holder.on("change", ".student-email", function(){
            handler.checkEmailSubmit();
        })
    }

    addExcelStudents(students){
        for (let i = 0; i < students.length; i++){
            const email = students[i].Emails;
            addEmailField(email);
        }
        refreshEmailFields();
        this.checkEmailSubmit();
    }


    showOption(){
        if (this.activationType == "email"){
            this.showEmail();
        } else if (this.activationType == "anonym"){
            this.showAnonym();
        }
    }

    hideTabs(){
        $(".activate-tab").hide();
    }

    checkEmailSubmit(){
        if (this.getEmails()[0]){
            this.submitBtn.prop("disabled", false);
        } else {
            this.submitBtn.prop("disabled", true);
        }
    }

    showEmail(){
        this.hideTabs();
        const returns = this.getEmails();
        if (returns[0]){
            this.submitBtn.prop('disabled', false);
        } else {
            this.submitBtn.prop('disabled', true);
        }
        $(".activate-students-email").show();
    }

    showAnonym(){
        this.hideTabs();
        this.submitBtn.prop('disabled', false);
        $(".activate-students-anonym").show();
    }

    getEmails(){
        if (this.activationType == "email"){
            const validMails = [];
            let countErrors = 0;
            const mails = $(".student-email");
            mails.each(function(ind, obj){
                const mail = $(obj).val().replace(/\s/g, "");
                if (mail !== '' && !checkEmail(mail)){  // es darf ruhig freie Mails geben
                    $(obj).addClass("is-invalid");
                    countErrors++;
                } else if (mail !== '') {
                    $(obj).removeClass("is-invalid").addClass("is-valid");
                    validMails.push(mail);
                }
            });
            if (validMails.length > 0 && countErrors == 0){
                return [true, validMails];
            } else {
                return [false];
            }
        } else {
            return [false];
        }
    }

    submit(btn:JQuery){
        this.submitEmails(this.courseId, btn)
        // if (this.activationType == "email"){
        //     this.submitEmails(this.courseId, btn);
        // } else if (this.activationType == "anonym"){
        //     this.submitAnonym(this.courseId, btn);
        // }
    }

    submitEmails(courseId:number, btn:JQuery){
        const returns = this.getEmails();
        if (returns[0]){

            const url = '/course/' + courseId.toString() + '/users/invite'

            const mails = returns[1];

            const data = {
                mails: mails
            }

            const self = this;

            const success = function (data){

                console.log(data)

                if (data.invitations === 0 && data.activations === 0){
                    errorToast("Es konnte niemand aktiviert werden")
                    return;
                }

                if (data.invitations > 0){
                    infoToast("Es wurden " + data.invitations + " Schüler/-innen vorgemerkt, da diese noch keinen Account besitzen", "Erfolg", 12500, true);
                }

                if (data.activations > 0){
                    successToast("Es wurden " + data.activations + " Schüler/-innen aktiviert", "Erfolg", 10000, true);
                }

                if (self.role == 'admin'){
                    // Change Counter
                    changeCourseListUserCounter(data.activations + data.invitations);
                    // Jetzt noch aktivierte Schüler reloaden!
                    fillActivateStudents(courseId);
                }
                // remove the emails
                $(".activate-students-email").find(".input-group").each((ind, obj) => {
                    if (ind > 0){
                        $(obj).remove()
                    }
                })

                hideModal("activate-students")
            }

            ajaxRequest(url, success, data, btn)

        } else {
            alert("Mindestens eine Mail ist fehlerhaft!");
        }
    }

    submitAnonym(courseId:number, btn:JQuery){
        const amount = $("#count-anonym-students").val();

        const config = {
            data: {
                action: "activate_students_anonym",
                amount: amount,
                courseId: courseId,
            },
            success: function(data){
                if (data.success){
                    successToast("Es wurden " + data.activatedAccounts + " anonyme Accounts erstellt", "Erfolg", 10000, true);
                    // Change Counter
                    changeCourseListUserCounter(data.activatedAccounts);
                    // Jetzt noch aktivierte Schüler reloaden!
                    fillActivateStudents(courseId);
                    // Hide Modal
                    hideModal("activate-students");
                } else {
                    errorToast(data.message, "Fehler", 15000, true);
                }
            }
        }
        ajaxSpinner(config, btn);
    }
}